import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoginAttempt } from '../third-party-login/third-party-login.component';

@Injectable({
    providedIn: 'root',
})
export class SelectionService {
    private loginFormData: LoginAttempt | null = null;

    private selectedItemSubject = new BehaviorSubject<string>('');
    selectedItem$ = this.selectedItemSubject.asObservable();

    private selectedSectionSubject = new BehaviorSubject<string>('');
    selectedSection$ = this.selectedSectionSubject.asObservable();

    private isLandingPageSubject = new BehaviorSubject<boolean>(true);
    isLandingPage$ = this.isLandingPageSubject.asObservable();

    setIsLandingPage(value: boolean) {
        this.isLandingPageSubject.next(value);
    }

    setSelectedItem(item: string) {
        this.selectedItemSubject.next(item);
    }

    setSelectedSection(section: string) {
        this.selectedSectionSubject.next(section);
    }
    setLoginFormData(data: LoginAttempt) {
        this.loginFormData = data;
    }

    getLoginFormData(): LoginAttempt | null {
        return this.loginFormData;
    }
}
